import { useActiveContext } from './useActiveContext';
import { useAuth } from './useAuth';

/**
 * Hook to check if the active context is ready for API calls
 *
 * This prevents race conditions where queries run before the X-Active-Context-Id
 * header is set on the axios instance.
 *
 * @returns true if active context is set OR if user has no context (guest/new user)
 */
export function useActiveContextReady(): boolean {
  const { activeContextId } = useActiveContext();
  const { user } = useAuth();

  // If user is not loaded yet, not ready
  if (!user) {
    return false;
  }

  // If activeContextId is set, we're ready (either from initialization or manual switch)
  if (activeContextId) {
    return true;
  }

  // If user has no active context in their profile, they're ready (first-time user or no context assigned)
  if (!user.activeContext?.id) {
    return true;
  }

  // User has a context in their profile, but it hasn't been set yet - not ready
  return false;
}
